export default __webpack_public_path__ + "static/media/features-home-element-02.6cebc894.png";